import { useAuthorization } from "@/Common/hooks/Authorization/Authorization";
import { IPVRMaxGraphValues, ISystemSettings } from "@/Settings/types/Common/model";
import { Grid } from "@mui/material";
import actionsList from "@/Constants/actionsList";
import MaxPVR from "./MaxPVR";
import { TPropertyParam } from "@/Settings/types/SystemSettings/pVRMaxValues";

const getSelected = (property: TPropertyParam, pvrMaxGraphValues?: IPVRMaxGraphValues) => {
	if (pvrMaxGraphValues?.[property]) {
		return {
			value: pvrMaxGraphValues[property],
			label: `$${pvrMaxGraphValues[property]}000`,
		};
	}
	return { value: 1, label: "$1000" };
};

type TPVRMaxValuesProps = {
	locationId: string;
	systemSettings?: ISystemSettings | null;
};

const PVRMaxValues = (props: TPVRMaxValuesProps) => {
	const { locationId, systemSettings } = props;
	const { useAuth } = useAuthorization();
	const disabled = !useAuth(actionsList.EDIT_PVR_MAX_VALUES);

	return (
		<>
			<Grid container className="!mt-[16px]">
				<Grid item xs={4}>
					<MaxPVR
						property="maxNewVehiclesPVR"
						selected={getSelected("maxNewVehiclesPVR", systemSettings?.pvrMaxGraphValues)}
						pvrMaxGraphValues={systemSettings?.pvrMaxGraphValues}
						title="Max New Vehicle PVR"
						info="Define the maximum PVR for new Vehicles."
						locationId={locationId}
						disabled={disabled}
					/>
				</Grid>
				<Grid item>
					<MaxPVR
						property="maxPreOwnedVehiclesPVR"
						selected={getSelected("maxPreOwnedVehiclesPVR", systemSettings?.pvrMaxGraphValues)}
						pvrMaxGraphValues={systemSettings?.pvrMaxGraphValues}
						title="Max Pre-Owned Vehicle PVR"
						info="Define the maximum PVR for Pre-Owned Vehicles."
						locationId={locationId}
						disabled={disabled}
					/>
				</Grid>
			</Grid>
			<Grid container className="!mt-[32px]">
				<Grid item xs={4}>
					<MaxPVR
						property="maxFinancePVR"
						selected={getSelected("maxFinancePVR", systemSettings?.pvrMaxGraphValues)}
						pvrMaxGraphValues={systemSettings?.pvrMaxGraphValues}
						title="F&I Average PVR"
						info="Define the maximum PVR for F&I."
						locationId={locationId}
						disabled={disabled}
					/>
				</Grid>
				<Grid item>
					<MaxPVR
						property="maxTotalPVR"
						selected={getSelected("maxTotalPVR", systemSettings?.pvrMaxGraphValues)}
						pvrMaxGraphValues={systemSettings?.pvrMaxGraphValues}
						title="Total PVR"
						info="Define the maximum total PVR."
						locationId={locationId}
						disabled={disabled}
					/>
				</Grid>
			</Grid>
		</>
	);
};

export default PVRMaxValues;
